const timer = {
  timerId: null,
  timer() {
    const datetime = $(".js-expiration-datetime").val();
    const timer = $(".js-countdown-timer");

    if (datetime) {
      const date = this.createDateAsUTC(datetime);
      const diff = this.getDiffInSeconds(date);

      if (diff < 1) {
        return;
      }

      timer.css("display", "flex");

      if (this.timerId) {
        this.clear();
      }

      this.timerId = setTimeout(this.tick.bind(this), 1000, timer, date);

    }
  },

  clear() {
    clearTimeout(this.timerId);
    this.timerId = null;
  },

  tick(timer, date) {
    let diff = this.getDiffInSeconds(date);

    if (diff > 0) {
      const time = this.getMinesAndSecondsFromSeconds(diff);
      timer.find(".js-minutes").html(time[0]);
      timer.find(".js-seconds").html(time[1]);

      this.timerId = setTimeout(this.tick.bind(this), 1000, timer, date);
    } else {
      timer.find(".js-minutes").html("00");
      timer.find(".js-seconds").html("00");
      $(".js-countdown-is-over-modal").fadeIn("easing");
    }
  },

  getMinesAndSecondsFromSeconds(seconds) {
    let minutes = Math.floor(seconds / 60);
    seconds = seconds - minutes * 60;
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return [minutes, seconds];
  },

  getDiffInSeconds(date1, date2 = new Date()) {
    const diff = date1.getTime() - date2.getTime();
    let seconds = Math.floor(diff / 1000);

    return seconds;
  },

  createDateAsUTC(datetime) {
    const date = new Date(datetime);

    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }
};

export default timer;

$(() => {
  timer.timer();
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/countdown-timer.js